import { render, staticRenderFns } from "./FootIndex.vue?vue&type=template&id=6078d14b&scoped=true"
import script from "./FootIndex.vue?vue&type=script&lang=js"
export * from "./FootIndex.vue?vue&type=script&lang=js"
import style0 from "./FootIndex.vue?vue&type=style&index=0&id=6078d14b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6078d14b",
  null
  
)

export default component.exports